import fetchLatestProcessLog from './fetchLatestProcessLog';

export default async function fetchLatestProcessLogForPress({
  press,
  project,
  process,
  production = null,
  pPart = null,
  stepPPartId = null,
  orderByField = 'start',
}) {
  if (press) {
    const samePressLog = await fetchLatestProcessLog({
      project,
      process,
      press,
      production,
      pPart,
      stepPPartId,
      orderByField,
    });

    if (samePressLog) {
      return samePressLog;
    }
  }

  return fetchLatestProcessLog({
    project,
    process,
    production,
    pPart,
    stepPPartId,
    orderByField,
  });
}
